// TODO: убрать эту заглушку, скорее всего отрефакторить
// eslint-disable-next-line import/no-mutable-exports
let store;

export const setStore = (st) => { store = st; };
export { store };

export const getState = () => store.getState();
